import React from "react";
import { Select, Typography } from "antd";
// import { DownloadOutlined } from "@ant-design/icons";
import NPSChevronIcon from "./NPSChevronIcon";
import "./NPSDashboardHeader.css";

const { Title, Text } = Typography;

const NPSDashboardHeader = ({ period, onPeriodChange, periodOptions, city, onCityChange, cityOptions, onExport }) => (
  <div className="nps-page-head">
    <div>
      <Title level={3} className="nps-page-title">NPS overview</Title>
      <Text className="nps-page-sub">Post-delivery survey shown on Track order</Text>
    </div>
    <div className="nps-head-actions">
      <Select
        className="nps-head-select"
        value={period}
        onChange={onPeriodChange}
        options={periodOptions}
        suffixIcon={<NPSChevronIcon />}
      />
      <Select
        className="nps-head-select"
        value={city}
        onChange={onCityChange}
        options={[{ value: "", label: "All cities" }, ...cityOptions]}
        suffixIcon={<NPSChevronIcon />}
      />
      {/* <Button type="primary" icon={<DownloadOutlined />} onClick={onExport}>
        Export CSV
      </Button> */}
    </div>
  </div>
);

export default NPSDashboardHeader;
